export const extractHourFromDate = (date) => {
  let hourConverted = new Date(date.slice(0, 16)).toLocaleTimeString("fr-FR");
  hourConverted = hourConverted.substring(0, 5);
  return hourConverted;
};

export const bigNumberDateAgenda = (date, heure) => {
  // Parser la date au format français DD/MM/YYYY
  const [dayPart, monthPart, yearPart] = date.split('/');
  const dateObject = new Date(yearPart, monthPart - 1, dayPart);

  const number = dateObject.toLocaleDateString("fr-FR", { day: "numeric" });
  const day = dateObject.toLocaleDateString("fr-FR", { weekday: "long" });
  const month = dateObject.toLocaleDateString("fr-FR", { month: "long" });
  const year = dateObject.toLocaleDateString("fr-FR", { year: "numeric" });
  const hour = heure;

  return (
    <div>
      <div className='subtitle'>{day}</div>
      <div className='date'>{number}</div>
      <div className='subtitle'>
        {month} {year}
      </div>
      <div className='subtitle'>{hour}</div>
    </div>
  );
};
